import { AxiosInstance } from 'axios'
import { BASE_API_URL } from 'constant'
import Fetcher from 'services/Fetcher'

class BaseApiCall {
  public api: AxiosInstance

  constructor() {
    this.api = Fetcher.createAuthAxios(BASE_API_URL, 'access_token')
  }

  login(payload) {
    return this.api.post(`/user/login`, payload)
  }

  ForgotPassword = {
    sendEmail: (payload) => {
      return this.api.post(`/user/forgot-password`, payload)
    },
    resetPassword: (payload) => {
      return this.api.post(
        `/user/reset-password/${payload.id}/${payload.token}`,
        payload.body,
      )
    },
  }

  User = {
    get: (page, pageSize, filtered) => {
      const filter = [...filtered]
      return this.api.get(
        `/user?page=${page}&pageSize=${pageSize}${
          filtered
            ? `&filtered=${encodeURIComponent(JSON.stringify(filter))}`
            : ''
        }`,
      )
    },
    create: (data) => {
      return this.api.post(`/user/register`, data)
    },
    delete: (id) => {
      return this.api.delete(`/user/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/user/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/user/${id}`, data)
    },
    download_excel: () => {
      return this.api.get(`/excel-user`, { responseType: 'blob' })
    },
    batch_register: (formData) => {
      return this.api.post(`/user/batch-upload`, formData, {
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
  }

  Halaman = {
    get: (page, pageSize, filtered) => {
      const filter = [...filtered]
      return this.api.get(
        `/halaman?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
          JSON.stringify(filter),
        )}`,
      )
    },
    create: (data) => {
      return this.api.post(`/halaman`, data)
    },
    delete: (id) => {
      return this.api.delete(`/halaman/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/halaman/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/halaman/${id}`, data)
    },
  }

  FAQ = {
    get: (page, pageSize, filtered) => {
      const filter = [...filtered]
      return this.api.get(
        `/faq?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
          JSON.stringify(filter),
        )}`,
      )
    },
    create: (data) => {
      return this.api.post(`/faq`, data)
    },
    delete: (id) => {
      return this.api.delete(`/faq/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/faq/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/faq/${id}`, data)
    },
  }

  Promotion = {
    get: (page, pageSize, filtered = []) => {
      const filter = [...filtered]
      return this.api.get(
        `/promotions?page=${page}&pageSize=${pageSize}${
          filtered
            ? `&filtered=${encodeURIComponent(JSON.stringify(filter))}`
            : ''
        }`,
      )
    },
    create: (data) => {
      return this.api.post(`/promotion`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    delete: (id) => {
      return this.api.delete(`/promotion/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/promotion/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/promotion/${id}`, data)
    },
  }

  Panduan = {
    get: (page, pageSize, filtered) => {
      const filter = [
        {
          id: `title`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      return this.api.get(
        `/guides?page=${page}&pageSize=${pageSize}${
          filtered
            ? `&filtered=${encodeURIComponent(JSON.stringify(filter))}`
            : ''
        }`,
      )
    },
    create: (data) => {
      return this.api.post(`/guide`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    delete: (id) => {
      return this.api.delete(`/guide/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/guide/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/guide/${id}`, data)
    },
  }

  Documents = {
    get: (page, pageSize, filtered) => {
      const filter = [
        {
          id: `title`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      return this.api.get(
        `/documents?page=${page}&pageSize=${pageSize}${
          filtered
            ? `&filtered=${encodeURIComponent(JSON.stringify(filter))}`
            : ''
        }`,
      )
    },
    create: (data) => {
      return this.api.post(`/document`, data)
    },
    delete: (id) => {
      return this.api.delete(`/document/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/document/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/document/${id}`, data)
    },
  }

  LaporanKeuangan = {
    get: (page, pageSize, filtered) => {
      const filter = [
        {
          id: `title`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      return this.api.get(
        `/laporan-keuangan?page=${page}&pageSize=${pageSize}${
          filtered
            ? `&filtered=${encodeURIComponent(JSON.stringify(filter))}`
            : ''
        }`,
      )
    },
    create: (data) => {
      return this.api.post(`/laporan-keuangan`, data)
    },
    delete: (id) => {
      return this.api.delete(`/laporan-keuangan/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/laporan-keuangan/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/laporan-keuangan/${id}`, data)
    },
  }

  Gallery = {
    get: (page, pageSize, filtered, type) => {
      const filterTitle = [
        {
          id: `name`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]
      const filterByCategory = [
        {
          id: 'category',
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      if (filtered) {
        return this.api.get(
          `/gallery?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
            JSON.stringify(
              type === 'category' ? filterByCategory : filterTitle,
            ),
          )}`,
        )
      }

      return this.api.get(`/gallery?page=${page}&pageSize=${pageSize}`)
    },
    instagram: () => {
      return this.api.get(`/instagram-gallery`)
    },
    create: (data) => {
      return this.api.post(`/gallery`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    delete: (id) => {
      return this.api.delete(`/gallery/${id}`)
    },
  }

  Article = {
    get: (page, pageSize, filtered, type) => {
      const filterTitle = [
        {
          id: `tittle`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]
      const filterType = [
        {
          id: `type`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]
      const filterByCategory = [
        {
          id: 'Category.name',
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      if (filtered) {
        return this.api.get(
          `/articles?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
            JSON.stringify(
              type === 'category'
                ? filterByCategory
                : type === 'filterType'
                ? filterType
                : filterTitle,
            ),
          )}`,
        )
      }

      return this.api.get(`/articles?page=${page}&pageSize=${pageSize}`)
    },
    create: (data) => {
      return this.api.post(`/article`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    delete: (id) => {
      return this.api.delete(`/article/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/article/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/article/${id}`, data)
    },
    getAllEvent: (page, pageSize, filtered) => {
      if (filtered) {
        return this.api.get(
          `/article?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
            JSON.stringify(filtered),
          )}`,
        )
      }

      return this.api.get(`/article?page=${page}&pageSize=${pageSize}`)
    },
    getByType: (page, pageSize, filtered, type) => {
      const filterType = [
        {
          id: `type`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      if (filtered) {
        return this.api.get(
          `/articles?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
            JSON.stringify(filterType),
          )}`,
        )
      }

      return this.api.get(`/articles?page=${page}&pageSize=${pageSize}`)
    },
  }

  Pengumuman = {
    get: (page, pageSize, filtered, type) => {
      const filterTitle = [
        {
          id: `tittle`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]
      const filterByCategory = [
        {
          id: 'Category.name',
          value: `${filtered === null ? '' : filtered}`,
        },
      ]

      if (filtered) {
        return this.api.get(
          `/announcement?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
            JSON.stringify(
              type === 'category' ? filterByCategory : filterTitle,
            ),
          )}`,
        )
      }

      return this.api.get(`/announcement?page=${page}&pageSize=${pageSize}`)
    },
    create: (data) => {
      return this.api.post(`/announcement`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    delete: (id) => {
      return this.api.delete(`/announcement/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/announcement/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/announcement/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
  }

  Category = {
    get: (page, pageSize, filtered) => {
      const filter = [
        {
          id: `name`,
          value: `${filtered === null ? '' : filtered}`,
        },
      ]
      return this.api.get(
        `/categories?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
          JSON.stringify(filter),
        )}`,
      )
    },
    create: (data) => {
      return this.api.post(`/category`, data)
    },
    delete: (id) => {
      return this.api.delete(`/category/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/category/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/category/${id}`, data)
    },
  }

  Menu = {
    get: (suffix?: string) => {
      return this.api.get(`/menu${suffix}`)
    },
    create: (data) => {
      return this.api.post(`/menu`, data)
    },
    delete: (id) => {
      return this.api.delete(`/menu/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/menu/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/menu/${id}`, data)
    },
    subMenu: () => {
      return this.api.get('submenu')
    },
    sequence: (data) => {
      return this.api.post('/menu-sequence', data)
    },
  }

  Event = {
    get: (page, pageSize, filtered) => {
      const filter = []

      const URL = `/events?page=${page}&pageSize=${pageSize}`

      if (filtered?.search) {
        filter.push({ id: 'tittle', value: filtered?.search })
      }

      if (filtered?.calendarView) {
        filter.push({ id: 'calendarView', value: filtered?.calendarView })
      }

      if (filtered?.startDate) {
        filter.push(
          { id: 'fromDate', value: filtered?.startDate },
          { id: 'toDate', value: filtered?.endDate },
          { id: 'checked', value: String(filtered?.checked) },
        )
      }

      const URL_FILTER = `/events?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
        JSON.stringify(filter),
      )}`

      if (filter.length) {
        return this.api.get(URL_FILTER)
      }

      return this.api.get(URL)
    },
    create: (data) => {
      return this.api.post(`/event`, data)
    },
    delete: (id) => {
      return this.api.delete(`/event/${id}`)
    },
    getById: (id) => {
      return this.api.get(`/event/${id}`)
    },
    update: (id, data) => {
      return this.api.put(`/event/${id}`, data)
    },
  }

  Tagihan = {
    get: (page, pageSize, filtered) => {
      const filter = []
      const URL = `/tagihan?page=${page}&pageSize=${pageSize}`

      if (filtered?.search) {
        filter.push({ id: 'name', value: filtered?.search })
      }

      if (filtered?.month) {
        filter.push({ id: 'bulan', value: filtered?.month })
      }

      const URL_FILTER = `/tagihan?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
        JSON.stringify(filter),
      )}`

      if (filter.length) {
        return this.api.get(URL_FILTER)
      }

      return this.api.get(URL)
    },
    batch_register: (formData) => {
      return this.api.post(`/tagihan/batch-upload`, formData, {
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    generate_excel: (filtered) => {
      const filter = []
      const URL = `/excel-tagihan`

      if (filtered?.search) {
        filter.push({ id: 'name', value: filtered?.search })
      }

      if (filtered?.month) {
        filter.push({ id: 'bulan', value: filtered?.month })
      }

      const URL_FILTER = `/excel-tagihan?filtered=${encodeURIComponent(
        JSON.stringify(filter),
      )}`

      if (filter.length) {
        return this.api.get(URL_FILTER, { responseType: 'blob' })
      }

      return this.api.get(URL, { responseType: 'blob' })
      // return this.api.get(`${URL}`, { responseType: 'blob' })
    },
    send_notification: (data) => {
      return this.api.post(`/send-all-notification`, data)
    },
    send_person_notification: (id) => {
      return this.api.put(`/send-notif-tagihan/${id}`)
    },
    edit: (id, payload) => {
      return this.api.put(`/tagihan/${id}`, payload)
    },
    download_template: () => {
      return this.api.get(`/excel-unit-bayar`, { responseType: 'blob' })
    },
    download_rekapitulasi: (payload) => {
      return this.api.post(`/excel-rekapitulasi`, payload, {
        responseType: 'blob',
      })
    },
  }

  Invoice = {
    get: (page, pageSize, filtered) => {
      const filter = []
      const URL = `/invoice?page=${page}&pageSize=${pageSize}`

      for (const key in filtered) {
        filter.push({ id: key, value: filtered[key] })
      }

      const URL_FILTER = `/invoice?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
        JSON.stringify(filter),
      )}`

      if (filter.length) {
        return this.api.get(URL_FILTER)
      }

      return this.api.get(URL)
    },
    post: (payload) => {
      return this.api.post(`/invoice`, payload, {
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    put: (id, payload) => {
      return this.api.put(`/invoice/${id}`, payload)
    },
    putDokumen: (id, dokumen) => {
      return this.api.put(`/invoice/${dokumen}/${id}`)
    },
    delete: (id) => {
      return this.api.delete(`/invoice/${id}`)
    },
    unitBayar: (formData) => {
      return this.api.post(`/invoice/unit-bayar`, formData, {
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
  }

  Receipt = {
    post: (payload) => {
      return this.api.post(`/receipt`, payload, {
        timeout: 20 * 60 * 1000, // 20 menit
      })
    },
    putDokumen: (id, dokumen, receipt) => {
      return this.api.put(`/receipt/${dokumen}/${id}`, { receipt })
    },
  }

  Unit = {
    get: (page, pageSize, filtered) => {
      const filter = []
      const URL = `/unit?page=${page}&pageSize=${pageSize}`

      if (filtered?.unit) {
        filter.push({ id: 'unit', value: filtered?.unit })
      }

      const URL_FILTER = `/unit?page=${page}&pageSize=${pageSize}&filtered=${encodeURIComponent(
        JSON.stringify(filter),
      )}`

      if (filter.length) {
        return this.api.get(URL_FILTER)
      }

      return this.api.get(URL)
    },
  }
}

const ApiCall = new BaseApiCall()

export default ApiCall
